import config from 'config/index.js';

export function throwSafeError(error) {
  if (config.REACT_APP_SHOULD_THROW_SAFE_ERROR) {
    throw error;
  }
}
